import { TextField } from '@nexus/lib-react/dist/core/TextField/TextField';
import styled from '../../../../../../theme/styled';

const DateFieldContainer = styled.fieldset`
  border: none;
  padding: 0;
  margin: 0;

  * {
    box-sizing: border-box;
  }
`;

const DateInnerFieldsContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
`;

const StyledTextField = styled(TextField)`
  height: 48px;
  padding-right: ${({ theme }) => theme.sizes.s};
  text-align: center;
`;

const FieldContainer = styled.div`
  flex: 1;
`;

const InnerDivider = styled.div`
  :before {
    content: '/';
  }
  margin: 0 ${({ theme }) => theme.sizes.s};
  width: ${({ theme }) => theme.sizes.s};
  flex: 0 0 ${({ theme }) => theme.sizes.s};
`;

export default {
  DateFieldContainer,
  DateInnerFieldsContainer,
  StyledTextField,
  FieldContainer,
  InnerDivider,
};
